import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { RegisterPayload } from '../../../../types';
import { RegisterRequest } from '../../../requests/Auth/RegisterRequest';
import { successToast } from '../../../../../components/Toast/successToast';

type Props = {
	onSuccess: () => void;
	onError?: (error: AxiosError) => void;
	onSettled: () => void;
};

export const useRegisterMutation = ({
	onSuccess,
	onError,
	onSettled,
}: Props) => {
	return useMutation(
		({
			params,
			captchaToken,
		}: {
			params: RegisterPayload;
			captchaToken: string | null;
		}) => RegisterRequest(params, captchaToken),
		{
			onSuccess: () => {
				successToast('Registration Complete');
				if (onSuccess) onSuccess();
			},
			onError: (error: AxiosError) => {
				if (onError) onError(error);
			},
			onSettled: () => {
				if (onSettled) onSettled();
			},
		},
	);
};
